<template>
  <div
    :style="style"
    v-touch="{
      left: () => nextImg(),
      right: () => prevImg()
    }"
  >

    <div style="position:fixed; top: 15px; right: 10px;">
      <v-btn fab flat dark small @click="closeFullMobile" style="z-index:1;">
        <v-icon large>close</v-icon>
      </v-btn>
    </div>


    <div :style="mobileNavCounterStyle">
      <template v-if="showOnlySelected">
        <v-layout style="text-align: center; color: #757575;">
          <v-flex xs1></v-flex>
          <v-flex xs3 mb-3>
            <v-btn fab dark flat @click="prevImg" small style="z-index:1;">
              <v-icon large>chevron_left</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs4 class="pt-3" style="font-size: 18px;">
            {{ selectedImageIndex + 1 }}/{{ images.length }}
          </v-flex>
          <v-flex xs3>
            <v-btn fab dark flat @click="nextImg" small style="z-index:1;">
              <v-icon large>chevron_right</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
      </template>
      <span v-else :class="'pika-counter ' + (
        !showingImageNavigation ? ' img-transparent' : ''
        )" >{{ selectedImageIndex + 1 }}/{{ images.length }}
      </span>
    </div>

    <div :style="previewContainerStyle"
      ref="mobile-preview-full"
    >
      <div
        v-for="(image, imageIndex) in images"
        :ref="'compact-image-' + imageIndex"
        :key="imageIndex"
      >
        <div
          v-if="!showOnlySelected || imageIndex === selectedImageIndex"
          @click="changeMobileImage(image, imageIndex)"
          :ref="'thumbnail-ref-' + imageIndex"
        >
          <img
            style="width: 100%"
            :src="s3url + imgFolder + '/' + image.image"
            :class="'selected-compact ' + (
              imageIndex !== selectedImageIndex ? ' not-selected-compact' : ''
              )"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import methods from './../methods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})


export default {
  name: 'ObjectImagesFullMobile',

  data: () => {
    return {
      previewScrolledTop: 0,
      showOnlySelected: false
    }
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    compact: {
      type: Boolean,
      default: false
    },
    imgFolder: {
      type: String,
      default: null
    }
  },

  created () {
    this.changeImage(this.images[0], 0)
    window.addEventListener('scroll', this.scrollHandler)
  },

  destroyed () {
    window.removeEventListener('scroll', this.scrollHandler)
  },

  watch: {
    windowWidth (now, before) {
      if (!this.mobile) { return }
      if (now > before && this.windowWidth > this.windowHeight) {
        // switched to landscape
        // this.hideMobileBottomBar()
      } else if (now < before && this.windowWidth < this.windowHeight) {
        // switched to portrate
        // this.hideMobileBottomBar()
      }
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home'
    },

    style () {
      let style = {
        'background-color': 'rgba(255, 255, 255, 1)',
        width: '100%'
      }
      if (this.showOnlySelected) {
        style.height = '100%'
      }
      return style
    },

    imageHeight () {
      return this.windowWidth * 3 / 4
    },

    middleScreen () {
      return this.windowHeight / 2
    },

    paddingTop () {
      if (!this.showOnlySelected) {
        return 5
      }
      return this.middleScreen - (this.imageHeight / 2)
    },

    previewContainerStyle () {
      return {
        padding: this.paddingTop + 'px 0'
      }
    },

    mobileNavCounterStyle () {
      return {
        'z-index': 1501,
        height: '50px',
        width: '100%',
        position: 'fixed',
        right: 0,
        bottom: '30px'
      }
    }
  },

  methods: {
    ...methods,

    changeMobileImage (image, imageIndex) {
      if (this.showOnlySelected) {
        this.nextImg()
      } else {
        this.changeImage(image, imageIndex)
        this.showOnlySelected = !this.showOnlySelected
      }
    },

    closeFullMobile () {
      window.scrollTo(0, 0)
      this.closeFull()
    },

    hideMobileBottomBar () {
      alert('hideMobileBottomBar')
      window.scrollTop = window.scrollTop + 10
    },

    scrollHandler (e) {
      const top = window.scrollY
      // const middlePoint = top + this.middleScreen
      const middlePoint = top + 50
      this.previewScrolledTop = top

      let foundIndex = -1
      // find image index which is in center
      this.images.forEach((image, index) => {
        let ref = this.$refs['compact-image-' + index][0]
        //console.log(ref.offsetTop, middlePoint, ref.offsetTop - this.imageHeight)
        //console.log(ref.offsetTop, ref.offsetTop >= middlePoint, this.imageHeight)
        if (ref.offsetTop <= middlePoint &&
          (ref.offsetTop + this.imageHeight) > middlePoint) {
          foundIndex = index
        }
        if (foundIndex > -1) {
          if (this.selectedImageIndex !== foundIndex) {
            this.changeImage(this.images[foundIndex], foundIndex)
          }
        }
      })
    }
  }
}
</script>

<style>
.selected-compact  {
}
.not-selected-compact {
  opacity: 1;
}
.mobile-images-close-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  color: #BDBDBD !important;
  opacity:0.7;
  border-radius:50%;
  padding:5px 9px;
  width:35px;
  height:35px;
  cursor:pointer;
}
.close-btn-with-bg {
  color: white !important;
  background: rgba(0,0,0,0.7);
}
</style>
